import { useEffect, useState } from "react";
import LanguageContext from "./LanguageContext";

const LanguageContextWrapper = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [lang, setLang] = useState("mr");
  const [apiLang, setApiLang] = useState("1");

  return (
    <>
      <LanguageContext.Provider value={{ lang, apiLang, setApiLang, setLang }}>
        {children}
      </LanguageContext.Provider>
    </>
  );
};

export default LanguageContextWrapper;
